import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import type {IModalsStore, IModalPayload} from "data/stores/modals/modals.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

export interface IModalErrorController extends ViewController {
	i18n: ILocalizationStore;

	get isOpen(): boolean;
	get modalContent(): IModalPayload | null;

	close: () => void;
}

@injectable()
export class ModalErrorController implements IModalErrorController {
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private readonly _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get isOpen(): boolean {
		return this._modalsStore.modal === ModalType.ERROR;
	}

	get modalContent(): IModalPayload {
		return this._modalsStore.modalContent as IModalPayload;
	}

	close = () => {
		this._modalsStore.hideModal();
	};

	dispose() {
		window.removeEventListener("offline", this.onOffline);
	}

	init(param: void) {
		window.addEventListener("offline", this.onOffline);
	}

	private onOffline = () => {
		this._modalsStore.showModal(ModalType.ERROR, {
			message: this.i18n.t("global.errors.offline"),
		});
	};
}
